import React, {Component} from 'react';
import {truncate} from 'lodash';

import ProfileCard from './ProfileCard';
import {useAppContext} from '../hooks';
import {getBrandName} from './Brand';

export class ScrollingTestimonials extends Component {
  animationID = null;

  startTs = null;

  width = null;

  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {
    if (!this.props.paused) this.start();
    const el = document.querySelector('#scrolling-testimonials');
    this.width = el.scrollWidth;
  }

  componentDidUpdate(prevProps) {
    if (!prevProps.paused && this.props.paused) this.pause();
    if (prevProps.paused && !this.props.paused) this.start();
  }

  start = () => {
    this.animationID = window.requestAnimationFrame(this.step);
  };

  pause = () => {
    window.cancelAnimationFrame(this.animationID);
    this.startTs = null;
  };

  step = (timestamp) => {
    if (!this.startTs) this.startTs = timestamp;

    const progress = timestamp - this.startTs;
    let dx = -1 * ((progress / 40) % (this.width / 2));

    if (this.props.reverse) {
      dx = -1 * dx - this.width / 2;
    }

    this.setState({transform: `translateX(${dx}px)`});
    this.animationID = window.requestAnimationFrame(this.step);
  };

  render() {
    // The parent container is fixed and the testimonials scroll through it,
    // rendered twice over so the loop is seamless.
    const cards = (copy) => this.props.items.map((item) => (
      <ProfileCard
        title={item.name}
        subtitle={[item.title || item.role, item.company].filter(Boolean).join(', ')}
        image={item.image}
        description={truncate(item.text, {length: 150})}
        key={`${copy}-${item.id}`}
      />
    ));

    return (
      <div className="flex py-4" style={{transform: this.state.transform}} id="scrolling-testimonials">
        {cards('a')}
        {cards('b')}
      </div>
    );
  }
}

export const TestimonialSection = ({showHeader = true}) => {
  let {testimonials} = useAppContext();
  const [paused, setPaused] = React.useState(false);
  if (!testimonials) return null;

  // Only show featured
  testimonials = testimonials.filter((t) => t.featured);

  return (
    <div className="relative w-full overflow-hidden p-8">
      {showHeader && (
        <>
          <h3 className="text-center text-base font-bold uppercase tracking-wider text-indigo">
            Our community
          </h3>
          <h2 className="mt-2 mb-6 text-center text-2xl md:text-4xl font-black text-black">
            {`Join over 600,000 people using ${getBrandName()}`}
          </h2>
        </>
      )}
      <ScrollingTestimonials
        items={testimonials.slice(0, testimonials.length / 2)}
        paused={paused}
      />
      <ScrollingTestimonials
        items={testimonials.slice(testimonials.length / 2)}
        reverse
        paused={paused}
      />
      <div className="absolute bottom-2 right-2">
        <button
          type="button"
          className="p-1.5 text-indigo hover:text-indigo-dark rounded-full hover:bg-gray-100 transition-colors"
          onClick={() => setPaused((prev) => !prev)}
          aria-label={paused ? 'Resume testimonials' : 'Pause testimonials'}
        >
          {paused ? (
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="w-4 h-4" aria-hidden="true">
              <path fillRule="evenodd" d="M4.5 5.653c0-1.426 1.529-2.33 2.779-1.643l11.54 6.348c1.295.712 1.295 2.573 0 3.285L7.28 19.991c-1.25.687-2.779-.217-2.779-1.643V5.653z" clipRule="evenodd" />
            </svg>
          ) : (
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="w-4 h-4" aria-hidden="true">
              <path fillRule="evenodd" d="M6.75 5.25a.75.75 0 01.75-.75H9a.75.75 0 01.75.75v13.5a.75.75 0 01-.75.75H7.5a.75.75 0 01-.75-.75V5.25zm7.5 0A.75.75 0 0115 4.5h1.5a.75.75 0 01.75.75v13.5a.75.75 0 01-.75.75H15a.75.75 0 01-.75-.75V5.25z" clipRule="evenodd" />
            </svg>
          )}
        </button>
      </div>
    </div>
  );
};
